import React, { Component } from 'react';
import { Dialog, 
         DialogTitle, 
         DialogActions, 
         Button,
         Checkbox,
         DialogContent, 
         DialogContentText,
         FormControlLabel } from '@material-ui/core';
import profileService from '../../services/WebProfileService';

const styles = {
    userInfoContainer: {
        height: '60px',
        width: '550px',
        marginLeft : "20px"        
    }
}

function DeleteConfirmation(props) {
    const { onDismiss, show, onConfirm, email } = props;
    return (
        <Dialog open={show}>
            <DialogTitle>Delete User</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure you want to delete {email}</DialogContentText>
                <DialogActions>
                    <Button id='confirm-delete-user-button' onClick={onConfirm}>
                        Yes
                    </Button>
                    <Button
                        onClick={onDismiss}
                        color="primary">
                        No
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}

class EditUserDialog extends Component {

    constructor(props) {
        super(props);     
        const { petroffAccess, skylineAccess, mobileOnly } = this.props.userToEdit;        

        this.state = {
            showConfirmation : false,
            petroffAccess,
            skylineAccess,
            mobileOnly,
            initialState : {
                petroffAccess, 
                skylineAccess,
                mobileOnly
            }
        }
    }

    onDeleteClicked() {        
        this.setState({
            showConfirmation : true
        });
    }

    dismissDeleteConfirmation() {
        this.setState({
            showConfirmation : false
        });
    }

    async deleteConfirmed() {        
        let email = this.props.userToEdit.email
        await profileService.deleteUser(email);
        this.dismissDeleteConfirmation();
        this.props.onUpdateUser();
    }

    async onUserSaved() {
        const addAccess = [];
        const removeAccess = [];
        const { initialState } = this.state;
        const { petroffAccess, skylineAccess, mobileOnly } = this.state; 
        const { email } = this.props.userToEdit;        

        if(!initialState.petroffAccess && petroffAccess) {
            addAccess.push("Petroff");
        } else if(initialState.petroffAccess && !petroffAccess){
            removeAccess.push("Petroff")
        }

        if(!initialState.skylineAccess && skylineAccess) {
            addAccess.push("Skyline");
        } else if(initialState.skylineAccess && !skylineAccess){
            removeAccess.push("Skyline")
        }

        if(!initialState.mobileOnly && mobileOnly) {
            addAccess.push("MobileOnly");
        } else if(initialState.mobileOnly && !mobileOnly){
            removeAccess.push("MobileOnly")
        }

        await profileService.updatePermissions(email,addAccess,removeAccess);

        setTimeout(() =>{ 
            this.props.onUpdateUser() 
        }, 200);
    }


    render() {        
        if(this.props.userToEdit == null)
            return null;

        const { email } = this.props.userToEdit;        
        const { petroffAccess, skylineAccess, mobileOnly} = this.state;

        return (            
            <div>
                <Dialog id='edit-user-dialog' open={true}>
                    <DialogTitle>Edit User</DialogTitle>
                    <div style={styles.userInfoContainer}>                    
                        <FormControlLabel
                            id="petroff-access-edit-checkbox"
                            label="Petroff Access"
                            control={<Checkbox checked={petroffAccess}
                            onClick={() =>{this.setState({petroffAccess : !petroffAccess})}}/>}
                        />
                        <FormControlLabel
                            id="skyline-access-edit-checkbox"
                            label="Skyline Access"
                            control={<Checkbox checked={skylineAccess} 
                                            onClick={() =>{this.setState({skylineAccess : !skylineAccess})}} />}
                        />
                        <FormControlLabel
                            id="mobile-only-edit-checkbox"
                            label="Mobile Only"
                            control={<Checkbox checked={mobileOnly} 
                                            onClick={() =>{this.setState({mobileOnly : !mobileOnly})}} />}
                        />
                        <Button 
                            id='delete-user-button'                                         
                            variant="contained" 
                            color="primary"                            
                            onClick={() => {this.onDeleteClicked()}}>Delete User</Button>
                    </div>
                    <DialogActions>
                        <Button id='save-user-button' onClick={() => {this.onUserSaved()}}>Save User</Button>
                        <Button onClick={this.props.onCancel} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <DeleteConfirmation
                    id='delete-user-confirmation-dialog' 
                    onDismiss={() => this.dismissDeleteConfirmation()} 
                    show={this.state.showConfirmation}
                    onConfirm={async () => this.deleteConfirmed()}
                    email={email}
                    />
            </div>
        )
    }
}

export default EditUserDialog;